import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../frontend/components/Header';
import Footer from '../frontend/components/Footer';

const SomeoneElseEnrollment = () => {
  const navigate = useNavigate();
  const [sponsorDetails, setSponsorDetails] = useState({ firstName: '', lastName: '', phone: '', email: '' });
  const [beneficiaries, setBeneficiaries] = useState([]);

  const handleSponsorChange = (e) => {
    const { name, value } = e.target;
    setSponsorDetails(prev => ({ ...prev, [name]: value }));
  };

  const addBeneficiary = () => {
    setBeneficiaries([...beneficiaries, { firstName: '', lastName: '', gender: '', phone: '', dateOfBirth: '', relationship: '', email: '', state: '', homeAddress: '', preferredHospitalLocation: '', preferredHospital: '', idCard: null, passportPhoto: null }]);
  };

  const removeBeneficiary = (index) => {
    const updated = [...beneficiaries];
    updated.splice(index, 1);
    setBeneficiaries(updated);
  };

  const handleBeneficiaryChange = (index, e) => {
    const { name, value } = e.target;
    const updated = [...beneficiaries];
    updated[index][name] = value;
    setBeneficiaries(updated);
  };

  const handleBeneficiaryFileUpload = (index, e, field) => {
    const file = e.target.files[0];
    const updated = [...beneficiaries];
    updated[index][field] = file;
    setBeneficiaries(updated);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Submitting Someone Else Enrollment:', { sponsorDetails, beneficiaries });
  };

  return (
    <>
      <Header />
      <div style={styles.container}>
        <div style={styles.mainContent}>
          <h1 style={styles.heading}>Let's get them started in less than 24 hours.</h1>
          
          <div style={styles.progressContainer}>
            <div style={{...styles.progressBar, width: '50%'}}></div>
            <span style={styles.progressText}>50%</span>
          </div>

          <form onSubmit={handleSubmit}>
            {/* Sponsor Details */}
            <div style={styles.section}>
              <h3 style={styles.sectionTitle}>Sponsor's Details</h3>
              <p style={styles.sectionSubtitle}>Enter your details as the sponsor purchasing this plan.</p>
              <div style={styles.row}>
                <div style={styles.inputGroup}>
                  <label style={styles.label}>First Name</label>
                  <input type="text" name="firstName" placeholder="Enter sponsor's first name" value={sponsorDetails.firstName} onChange={handleSponsorChange} style={styles.input} required />
                </div>
                <div style={styles.inputGroup}>
                  <label style={styles.label}>Last Name</label>
                  <input type="text" name="lastName" placeholder="Enter sponsor's last name" value={sponsorDetails.lastName} onChange={handleSponsorChange} style={styles.input} required />
                </div>
              </div>
              <div style={styles.row}>
                <div style={styles.inputGroup}>
                  <label style={styles.label}>Phone Number</label>
                  <input type="tel" name="phone" placeholder="080XXXXXXXX" value={sponsorDetails.phone} onChange={handleSponsorChange} style={styles.input} required />
                </div>
                <div style={styles.inputGroup}>
                  <label style={styles.label}>Email Address</label>
                  <input type="email" name="email" placeholder="e.g., sponsor@email.com" value={sponsorDetails.email} onChange={handleSponsorChange} style={styles.input} required />
                </div>
              </div>
            </div>

            {/* Beneficiaries */}
            <div style={styles.section}>
              <h3 style={styles.sectionTitle}>Your Beneficiaries</h3>
              <p style={styles.sectionSubtitle}>Add the people who will receive health coverage from this plan.</p>
              
              {beneficiaries.map((beneficiary, index) => (
                <div key={index} style={styles.card}>
                  <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px'}}>
                    <h4 style={styles.cardTitle}>Beneficiary {index + 1}</h4>
                    <button type="button" onClick={() => removeBeneficiary(index)} style={{color: '#ef4444', background: 'none', border: 'none', cursor: 'pointer', fontSize: '14px'}}>
                      <i className="fas fa-trash"></i> Remove
                    </button>
                  </div>
                  
                  <div style={styles.row}>
                    <div style={styles.inputGroup}>
                      <label style={styles.label}>First Name</label>
                      <input type="text" name="firstName" placeholder="First name" value={beneficiary.firstName} onChange={(e) => handleBeneficiaryChange(index, e)} style={styles.input} required />
                    </div>
                    <div style={styles.inputGroup}>
                      <label style={styles.label}>Last Name</label>
                      <input type="text" name="lastName" placeholder="Last name" value={beneficiary.lastName} onChange={(e) => handleBeneficiaryChange(index, e)} style={styles.input} required />
                    </div>
                  </div>

                  <div style={styles.row}>
                    <div style={styles.inputGroup}>
                      <label style={styles.label}>Gender</label>
                      <select name="gender" value={beneficiary.gender} onChange={(e) => handleBeneficiaryChange(index, e)} style={styles.select} required>
                        <option value="">Select gender</option>
                        <option value="male">Male</option>
                        <option value="female">Female</option>
                        <option value="other">Other</option>
                      </select>
                    </div>
                    <div style={styles.inputGroup}>
                      <label style={styles.label}>Date of Birth</label>
                      <input type="date" name="dateOfBirth" value={beneficiary.dateOfBirth} onChange={(e) => handleBeneficiaryChange(index, e)} style={styles.input} required />
                    </div>
                  </div>

                  <div style={styles.row}>
                    <div style={styles.inputGroup}>
                      <label style={styles.label}>Relationship</label>
                      <select name="relationship" value={beneficiary.relationship} onChange={(e) => handleBeneficiaryChange(index, e)} style={styles.select} required>
                        <option value="">Select Relationship</option>
                        <option value="spouse">Spouse</option>
                        <option value="child">Child</option>
                        <option value="parent">Parent</option>
                        <option value="sibling">Sibling</option>
                        <option value="other">Other</option>
                      </select>
                    </div>
                    <div style={styles.inputGroup}>
                      <label style={styles.label}>Phone Number</label>
                      <input type="tel" name="phone" placeholder="080XXXXXXXX" value={beneficiary.phone} onChange={(e) => handleBeneficiaryChange(index, e)} style={styles.input} />
                    </div>
                  </div>

                  <div style={styles.row}>
                    <div style={styles.inputGroup}>
                      <label style={styles.label}>State (in Nigeria)</label>
                      <select name="state" value={beneficiary.state} onChange={(e) => handleBeneficiaryChange(index, e)} style={styles.select}>
                        <option value="">Select state of residence</option>
                        <option value="lagos">Lagos</option>
                        <option value="abuja">Abuja</option>
                      </select>
                    </div>
                    <div style={styles.inputGroup}>
                      <label style={styles.label}>Preferred Hospital Location</label>
                      <select name="preferredHospitalLocation" value={beneficiary.preferredHospitalLocation} onChange={(e) => handleBeneficiaryChange(index, e)} style={styles.select}>
                        <option value="">Select hospital location state</option>
                        <option value="lagos">Lagos</option>
                        <option value="abuja">Abuja</option>
                      </select>
                    </div>
                  </div>

                  <div style={styles.inputGroup}>
                    <label style={styles.label}>Preferred Hospital</label>
                    <input type="text" name="preferredHospital" placeholder="Search and select your preferred hospital" value={beneficiary.preferredHospital} onChange={(e) => handleBeneficiaryChange(index, e)} style={styles.input} />
                  </div>

                  <div style={styles.fileUploadSection}>
                    <div style={styles.fileUpload}>
                      <label style={styles.fileLabel}>Identification Card</label>
                      <div style={styles.fileInput}>
                        <input type="file" accept=".jpg,.jpeg,.png,.pdf" onChange={(e) => handleBeneficiaryFileUpload(index, e, 'idCard')} style={styles.hiddenFileInput} />
                        <div style={styles.filePlaceholder}>
                          <i className="fas fa-upload" style={styles.uploadIcon}></i>
                          <p>Choose a file</p>
                          <small style={styles.secureText}>🔒 Secure upload</small>
                        </div>
                      </div>
                    </div>
                    <div style={styles.fileUpload}>
                      <label style={styles.fileLabel}>Passport Photograph</label>
                      <div style={styles.fileInput}>
                        <input type="file" accept=".jpg,.jpeg,.png" onChange={(e) => handleBeneficiaryFileUpload(index, e, 'passportPhoto')} style={styles.hiddenFileInput} />
                        <div style={styles.filePlaceholder}>
                          <i className="fas fa-upload" style={styles.uploadIcon}></i>
                          <p>Choose a file</p>
                          <small style={styles.secureText}>🔒 Secure upload</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}

              <button type="button" onClick={addBeneficiary} style={styles.addButton}>
                <i className="fas fa-plus"></i> Add Beneficiary
              </button>
            </div>

            <div style={styles.navigation}>
              <button type="button" style={styles.prevButton} onClick={() => navigate(-1)}>
                <i className="fas fa-arrow-left"></i> Previous
              </button>
              <button type="submit" style={styles.continueButton}>
                Continue to Payment <i className="fas fa-arrow-right"></i>
              </button>
            </div>
          </form>
        </div>

        <div style={styles.sidebar}>
          <div style={styles.orderSummary}>
            <h3 style={styles.summaryTitle}>Order Summary</h3>
            <p style={styles.summarySubtitle}>Review your plan details and pricing</p>
            <div style={styles.summaryCard}>
              <div style={styles.summaryRow}>
                <span style={styles.summaryLabel}>Plan</span>
                <span style={styles.summaryValue}>Individual/Family Health Plan</span>
              </div>
              <div style={styles.summaryRow}>
                <span style={styles.summaryLabel}>Purchase Type</span>
                <span style={{...styles.purchaseType, backgroundColor: '#FFF3E0', color: '#F89423'}}>FOR SOMEONE ELSE</span>
              </div>
              <div style={styles.summaryRow}>
                <span style={styles.summaryLabel}>Beneficiaries</span>
                <span style={styles.summaryValue}>{beneficiaries.length}</span>
              </div>
            </div>
            <div style={styles.pricingSection}>
              <h4 style={styles.pricingTitle}>Pricing Breakdown</h4>
              <div style={styles.pricingRow}>
                <span>Principal/Purchaser</span>
                <span style={styles.price}>₦790,500</span>
              </div>
              <div style={styles.totalRow}>
                <span style={styles.totalLabel}>Total Amount</span>
                <span style={{...styles.totalAmount, color: '#F89423'}}>₦790,500</span>
              </div>
            </div>
            <button type="button" style={{...styles.paymentButton, borderColor: '#F89423', color: '#F89423'}}>Make Payment <i className="fas fa-arrow-right"></i></button>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

const styles = {
  container: { display: 'flex', maxWidth: '1200px', margin: '0 auto', padding: '40px 20px', gap: '40px' },
  mainContent: { flex: 1, maxWidth: '800px' },
  heading: { fontSize: '28px', fontWeight: '600', marginBottom: '30px', color: '#1a1a1a' },
  progressContainer: { position: 'relative', height: '8px', backgroundColor: '#e5e7eb', borderRadius: '4px', marginBottom: '40px' },
  progressBar: { height: '100%', backgroundColor: '#F89423', borderRadius: '4px', transition: 'width 0.3s ease' },
  progressText: { position: 'absolute', right: '0', top: '-25px', fontSize: '14px', color: '#F89423', fontWeight: '600' },
  section: { marginBottom: '40px' },
  sectionTitle: { fontSize: '18px', fontWeight: '600', marginBottom: '8px', color: '#1a1a1a' },
  sectionSubtitle: { fontSize: '14px', color: '#6b7280', marginBottom: '24px' },
  row: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px', marginBottom: '20px' },
  inputGroup: { display: 'flex', flexDirection: 'column', gap: '6px' },
  label: { fontSize: '14px', fontWeight: '500', color: '#374151' },
  input: { padding: '10px 14px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none', transition: 'border-color 0.2s' },
  select: { padding: '10px 14px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none', backgroundColor: 'white', cursor: 'pointer' },
  card: { border: '1px solid #e5e7eb', borderRadius: '8px', padding: '24px', marginBottom: '20px', backgroundColor: '#f9fafb' },
  cardTitle: { fontSize: '16px', fontWeight: '600', marginBottom: '0', color: '#1a1a1a' },
  fileUploadSection: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px', marginTop: '20px' },
  fileUpload: { display: 'flex', flexDirection: 'column', gap: '8px' },
  fileLabel: { fontSize: '14px', fontWeight: '500', color: '#374151' },
  fileInput: { position: 'relative' },
  hiddenFileInput: { position: 'absolute', width: '100%', height: '100%', opacity: '0', cursor: 'pointer' },
  filePlaceholder: { border: '2px dashed #d1d5db', borderRadius: '8px', padding: '24px', textAlign: 'center', backgroundColor: '#f9fafb', cursor: 'pointer', transition: 'all 0.2s' },
  uploadIcon: { fontSize: '24px', color: '#F89423', marginBottom: '8px' },
  secureText: { color: '#059669', fontSize: '11px', marginTop: '4px' },
  addButton: { display: 'inline-flex', alignItems: 'center', gap: '8px', padding: '10px 20px', border: '1px solid #d1d5db', borderRadius: '6px', backgroundColor: 'white', color: '#374151', fontSize: '14px', fontWeight: '500', cursor: 'pointer', marginTop: '16px' },
  navigation: { display: 'flex', justifyContent: 'space-between', marginTop: '40px', paddingTop: '24px', borderTop: '1px solid #e5e7eb' },
  prevButton: { display: 'inline-flex', alignItems: 'center', gap: '8px', padding: '12px 24px', border: 'none', backgroundColor: 'transparent', color: '#6b7280', fontSize: '14px', fontWeight: '500', cursor: 'pointer' },
  continueButton: { display: 'inline-flex', alignItems: 'center', gap: '8px', padding: '12px 24px', border: 'none', borderRadius: '6px', backgroundColor: '#F89423', color: 'white', fontSize: '14px', fontWeight: '600', cursor: 'pointer' },
  sidebar: { width: '350px', position: 'sticky', top: '100px', height: 'fit-content' },
  orderSummary: { backgroundColor: 'white', border: '1px solid #e5e7eb', borderRadius: '12px', padding: '24px', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)' },
  summaryTitle: { fontSize: '16px', fontWeight: '600', marginBottom: '4px', color: '#1a1a1a' },
  summarySubtitle: { fontSize: '13px', color: '#6b7280', marginBottom: '20px' },
  summaryCard: { backgroundColor: '#f9fafb', borderRadius: '8px', padding: '16px', marginBottom: '20px' },
  summaryRow: { display: 'flex', flexDirection: 'column', gap: '4px', marginBottom: '12px' },
  summaryLabel: { fontSize: '12px', color: '#6b7280' },
  summaryValue: { fontSize: '14px', fontWeight: '500', color: '#1a1a1a' },
  purchaseType: { display: 'inline-block', padding: '4px 8px', borderRadius: '4px', fontSize: '12px', fontWeight: '600', marginTop: '4px' },
  pricingSection: { marginBottom: '20px' },
  pricingTitle: { fontSize: '14px', fontWeight: '600', marginBottom: '12px', color: '#1a1a1a' },
  pricingRow: { display: 'flex', justifyContent: 'space-between', fontSize: '14px', color: '#6b7280', marginBottom: '8px' },
  price: { fontWeight: '500', color: '#1a1a1a' },
  totalRow: { display: 'flex', justifyContent: 'space-between', paddingTop: '12px', borderTop: '1px solid #e5e7eb', marginTop: '12px' },
  totalLabel: { fontSize: '14px', fontWeight: '600', color: '#1a1a1a' },
  totalAmount: { fontSize: '18px', fontWeight: '700' },
  paymentButton: { width: '100%', padding: '14px', border: '2px solid', borderRadius: '8px', backgroundColor: 'white', fontSize: '14px', fontWeight: '600', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', transition: 'all 0.2s' }
};

export default SomeoneElseEnrollment;